import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Quiz9: Translator = sequence => {
  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Question':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: 'right'
          },
          items: [
            {
              id: item.id,
              type: LAYOUT_LIST,
              values: { align: 'left' },
              items: [
                {
                  type: TEXT,
                  id: `${item.id}_subtitle`,
                  items: [],
                  values: {
                    value: item.subtitle,
                    variant: 'sub_heading',
                    icon: item.icon
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_title`,
                  items: [],
                  values: {
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_body`,
                  items: [],
                  values: {
                    value: item.body
                  }
                },
                {
                  type: QUIZ_CHOICE,
                  id: '1',
                  values: {
                    variant: item.items && item.items.length > 2 ? 'list' : '',
                    title: item?.title?.includes('?')
                      ? item.title
                      : item?.body?.includes('?')
                      ? item.body
                      : '',
                    length: item?.items?.length,
                    multiSelect: item?.items?.filter(
                      item => item.correct === true
                    ).length
                  },
                  items: AnswerButtonHelper({
                    group: item.id,
                    items: item.items,
                    llamaSurvey: item.llamaSurvey,
                    question: item.title || ''
                  })
                }
              ]
            } as LayoutListDefinition
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });
};
